var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditExperience.jinja');
require('./MemberProfileEditExperience.less');

var MemberProfileEditExperienceItem = require('front/components/MemberProfileEdit/MemberProfileEditExperienceItem');
var MemberProfileEditExperienceItemRuntime = require('front/components/MemberProfileEdit/MemberProfileEditExperienceItemRuntime.jinja');

require('jquery-ui/ui/widgets/sortable');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditExperience-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditExperience-buttons-button--save': 'saveEdit',
        'click .MemberProfileEditExperience-body-form-addInput': 'addExperience',
        'click .MemberProfileEditExperience-info': 'onInfoClick'
    },

    saveApi: function () {
        return Urls['member:api:member'](this.options.memberId, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'updateScroll', 'saveApi', 'onBodyClick');


        window.app.vent.on('MemberProfileEditExperienceItem-remove', this.updateScroll);

        this.$('.MemberProfileEditExperienceItem').each(function () {
            new MemberProfileEditExperienceItem({
                el: this
            });
        });

        if (!app.settings.isPhone) {
            this.experienceJsp = this.$('.MemberProfileEditExperience-body-scrollBlock')
                .jScrollPane()
                .bind('mousewheel', function (e) {
                    e.preventDefault();
                })
                .data('jsp');

            this.experienceSortable = this.$('.MemberProfileEditExperience-body-form').sortable({
                handle: '.MemberProfileEditExperienceItem-inputIcons-drag',
                scroll: true
            });

            this.scrollOnDrag = window.app.utils.scrollOnDrag({
                sortInstance: this.experienceSortable,
                scrollInstance: this.experienceJsp
            });
        }

        $(window).on('resize', this.updateScroll);
        this.updateScroll();

        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {

        $(window).off('resize', this.updateScroll);

        this.scrollOnDrag && this.scrollOnDrag.destroy();

        window.app.vent.off('MemberProfileEditExperienceItem-remove', this.updateScroll);

        return Base.prototype.deactivate.call(this, params);
    },


    onInfoClick: function (e) {
        if (app.settings.isDesktop) return;

        if ($(e.target).closest('.MemberProfileEditExperience-infoPopup').length) return;

        if ($(e.currentTarget).hasClass('MemberProfileEditExperience-info--active')) {
            this.closeAllInfoPopups();
        } else {
            this.closeAllInfoPopups();
            $(e.currentTarget).addClass('MemberProfileEditExperience-info--active');
            $('body').on('click', this.onBodyClick);
        }
    },


    closeAllInfoPopups: function () {
        this.$('.MemberProfileEditExperience-info').removeClass('MemberProfileEditExperience-info--active');

        $('body').off('click', this.onBodyClick);
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.MemberProfileEditExperience-info').length) return;

        this.closeAllInfoPopups();
    },


    saveEdit: function () {
        var data = [];
        var order = 0;
        var selector = app.settings.isPhone ? '.MemberProfileEditExperienceItem-textarea' : '.MemberProfileEditExperienceItem-input';


        this.$(selector).each(function () {
            var item = {};
            var text = $(this).val();
            var id = $(this).attr('data-id');

            if (text) {
                item.text = text;
                item.order = order++;

                if (id) {
                    item.id = id - 0;
                }

                data.push(item);
            }
        });

        var $button = this.$('.MemberProfileEditExperience-buttons-button--save');

        $button.addClass('Button--loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'PATCH',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                'experiences': data
            }),
            success: function (responseData) {

                app.vent.trigger('need-reload', 'my-adg');// refresh my-adg page if it's current underlying page, to update member info block on it

                $button.removeClass('Button--loading');

                //save response to cache, it's important for all popup edit panels, which renders on the fly to show actual data
                //response always contain all profile data up-to-date
                window.app.data.members[this.options.memberId] = responseData;

                window.app.vent.trigger('MemberProfile--updateExperience', this.options.memberId);

                this.cancelEdit();
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Can\'t update experiences!');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'experience');
    },


    addExperience: function () {
        var $template = $(MemberProfileEditExperienceItemRuntime.render({data: {}}));

        this.$('.MemberProfileEditExperience-body-form').append($template);

        new MemberProfileEditExperienceItem({
            el: $template[0]
        });

        if (!app.settings.isPhone) {
            this.experienceSortable.sortable('refresh');
            this.updateScroll();
            this.experienceJsp.scrollToBottom();
        }
    },


    updateScroll: function () {
        if (!app.settings.isPhone) {
            this.experienceJsp.reinitialise();
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditExperience.js
// module id = 206
// module chunks = 0